var Pricing = {
	init: function() {
		this.tooltips();
		this.switcher();
	},

	tooltips: function() {
		var $tooltip = $( '<div class="wpum-tooltip"></div>' );
		$( 'body' ).append( $tooltip );

		$( '[data-tooltip]' ).hover( function() {
			var $anchor = $( this ),
				position = $anchor.offset();

			$tooltip
				.html( $anchor.data( 'tooltip' ) )
				.css( {
					'left': (position.left + $anchor.outerWidth() / 2 - $tooltip.outerWidth() / 2) + 'px',
					'top': (position.top - $tooltip.outerHeight() - 5) + 'px'
				} )
				.show();
		}, function() {
			$tooltip.hide();
		} );
	},

	switcher: function() {
		var self = this;
		$( '.pricing-container .btn-group .btn' ).click( function() {
			var type = $( this ).data( 'pricing' );
			window.location.hash = type;
			self.toggle( type );
		} );
	},

	toggle: function( type ) {
		if ( $( '.pricing-container .btn-group .btn' ).hasClass( 'btn-white' ) ) {
			$( '.pricing-container .btn-group .btn' ).removeClass( 'active' )
			$( '.pricing-container .btn-group .btn[data-pricing="' + type + '"]' ).addClass( 'active' );
		} else {
			$( '.pricing-container .btn-group .btn' ).removeClass( 'btn-primary' ).addClass( 'btn-outline-primary' );
			$( '.pricing-container .btn-group .btn[data-pricing="' + type + '"]' ).removeClass( 'btn-outline-primary' ).addClass( 'btn-primary' );
		}

		$( '.pricing-container .pricing' ).removeClass( 'active' );
		$( '.pricing-container .pricing[data-pricing=\'' + type + '\']' ).addClass( 'active' );
	},

	param: function( name ) {
		return (location.search.split( name + '=' )[ 1 ] || '').split( '&' )[ 0 ];
	}

};

$( document ).on( 'ready', function() {

	if ( ! $('body.page-template-pricing').length && ! $('body.single-download').length ){
		return;
	}

	Pricing.init();

	if ( $( '.license-toggle' ).length ) {
		var type = window.location.hash.substr(1);
		if ( type.length && [ 'yearly', 'lifetime' ].includes(type) ) {
			Pricing.toggle( type );
		}
	}
} );